document.querySelector("a[href='#statespopup']").addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default anchor behavior

    // Find the closest parent div with class "lead"
    let parentDiv = this.closest(".lead");

    if (parentDiv) {
        document.getElementById("popup").style.display = "flex";
        }
    });
    
    // Close popup on button click
    document.getElementById("closePopup").addEventListener("click", function () {
        document.getElementById("popup").style.display = "none";
    });
    
    // Close popup when clicking outside the content
    window.addEventListener("click", function (event) {
        if (event.target === document.getElementById("popup")) {
            document.getElementById("popup").style.display = "none";
        }
    });